import React from 'react';
import { Link } from 'react-router-dom';
import { UtensilsCrossed, Martini, ChefHat, TreePine, ArrowRight } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Reveal, Kicker } from '../components/Reveal';
import { SEO } from '../components/SEO';
import { Banner } from './Home';

const icons = [UtensilsCrossed, Martini, ChefHat, TreePine];

export default function ChristmasParty() {
  const { t } = useLanguage();

  return (
    <div data-testid="christmas-page">
      <SEO title={t.meta.xmasTitle} description={t.meta.xmasDesc} />

      <section className="relative pt-40 pb-24 md:pb-32 bg-emerald-deep grain overflow-hidden" data-testid="xmas-hero">
        <div className="absolute inset-0 opacity-45">
          <img src="/images/christmas-party.jpg" alt="" className="h-full w-full object-cover" />
        </div>
        <div className="absolute inset-0 bg-emerald-deep/50" />
        <div className="relative max-w-7xl mx-auto px-6 md:px-10">
          <Reveal>
            <Kicker light>{t.xmas.kicker}</Kicker>
            <h1 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl text-ivory tracking-tight max-w-4xl">{t.xmas.title}</h1>
            <p className="mt-6 max-w-2xl text-ivory/70 text-base md:text-lg leading-relaxed">{t.xmas.intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32" data-testid="xmas-formats">
        <Reveal>
          <Kicker>{t.xmas.formatsKicker}</Kicker>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.xmas.formats.map((f, i) => {
            const Icon = icons[i];
            return (
              <Reveal key={f.title} delay={i * 0.08}>
                <article
                  data-testid={`xmas-format-${i}`}
                  className="h-full bg-white border border-emerald/10 rounded-sm p-8 transition-all duration-500 hover:shadow-[0_12px_50px_rgba(37,79,87,0.14)] hover:-translate-y-1"
                >
                  <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-ivory text-terracotta-dark">
                    <Icon size={22} strokeWidth={1.5} />
                  </span>
                  <h2 className="mt-6 font-serif text-2xl text-emerald">{f.title}</h2>
                  <p className="mt-3 text-sm text-emerald-ink/60 leading-relaxed">{f.desc}</p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="bg-ivory-soft border-y border-emerald/10" data-testid="xmas-menu">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="img-frame rounded-sm shadow-[0_8px_40px_rgba(37,79,87,0.15)]">
              <img src="/images/natale-location.jpg" alt={t.xmas.menuTitle} className="w-full aspect-[4/5] object-cover" loading="lazy" data-testid="xmas-menu-photo" />
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <Kicker>{t.xmas.menuTitle}</Kicker>
            <p className="mt-6 text-emerald-ink/70 text-base md:text-lg leading-relaxed">{t.xmas.menuText}</p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link
                to="/servizi"
                data-testid="xmas-cta-services"
                className="rounded-full bg-emerald text-ivory text-sm px-7 py-3 transition-all duration-300 hover:bg-terracotta-dark hover:-translate-y-0.5 inline-flex items-center gap-2"
              >
                {t.xmas.menuCta}
                <ArrowRight size={16} />
              </Link>
              <Link
                to="/contatti"
                data-testid="xmas-cta-contact"
                className="rounded-full border border-emerald/30 text-emerald text-sm px-7 py-3 transition-all duration-300 hover:border-terracotta-dark hover:text-terracotta-dark"
              >
                {t.xmas.bannerCta}
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      <Banner title={t.xmas.bannerTitle} text={t.xmas.bannerText} cta={t.xmas.bannerCta} />
    </div>
  );
}
